export class User {
  constructor(
    public id: number,
    public avatar: string = '',
    public nickname: string = '',
    public sex: string = '',
    public email: string = '',
    public phone: string = '',
    public address: string = '',
    public active: number = 0,
    public staffCode: string = '',
    public updatePasswordTime: string = ''
  ) {

  }
}
